var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chatbot-status-widget" },
    [
      _c(
        "md-button",
        {
          ref: "buttonRef",
          staticClass:
            "actionButtonBreadcrumb m-0 chatbot-btn chatbot-status-button",
          staticStyle: { "min-width": "20px", "max-width": "25px" },
          on: {
            mouseenter: function ($event) {
              _vm.chatbotIconHovered = true
            },
            mouseleave: function ($event) {
              _vm.chatbotIconHovered = false
            },
            click: _vm.toggleDropdown,
          },
        },
        [
          _c("ChatbotIcon", {
            staticClass: "chatbot-icon",
            attrs: {
              color:
                _vm.chatbotIconHovered || _vm.isDropdownVisible
                  ? _vm.getIconColor()
                  : "#3A3F48",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isDropdownVisible
        ? _c(
            "div",
            {
              staticClass: "chatbot-custom-dropdown",
              class: { "chatbot-dropdown-ready": _vm.dropdownReady },
              style: _vm.dropdownStyle,
            },
            [
              _c("div", { staticClass: "chatbot-dropdown-content" }, [
                _c("div", { staticClass: "chatbot-section-header" }, [
                  _c("span", { staticClass: "chatbot-header-title" }, [
                    _vm._v("Chatbot İstatistikleri"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "chatbot-status-indicator",
                      class: _vm.getStatusClass(),
                    },
                    [
                      _c("span", { staticClass: "chatbot-status-dot" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "chatbot-status-text" }, [
                        _vm._v(_vm._s(_vm.getStatusText())),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      { staticClass: "chatbot-icon-box total" },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("forum"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-details" }, [
                      _c("div", { staticClass: "chatbot-stat-title" }, [
                        _vm._v("Toplam Chatbot"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-desc" }, [
                        _vm._v(_vm._s(_vm.$t("message.maxSessionCount"))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chatbot-stat-number total" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.features.totalSessionCount || 0).toLocaleString()
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      { staticClass: "chatbot-icon-box free" },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("card_giftcard"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(0),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chatbot-stat-number free" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.features.freeSessionCount || 0).toLocaleString()
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      { staticClass: "chatbot-icon-box extra" },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("bolt"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(1),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chatbot-stat-number extra" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.features.extraSessionCount || 0).toLocaleString()
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      { staticClass: "chatbot-icon-box used" },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("check_circle"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-details" }, [
                      _c("div", { staticClass: "chatbot-stat-title" }, [
                        _vm._v("Kullanılan Chatbot"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-desc" }, [
                        _vm._v(
                          _vm._s(_vm.getUsagePercentage().toFixed(1)) +
                            "% kullanıldı"
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chatbot-stat-number used" }, [
                    _vm._v(
                      _vm._s((_vm.totalChatbotUsage || 0).toLocaleString())
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      {
                        staticClass: "chatbot-icon-box remaining",
                        class: _vm.getStatusClass(),
                      },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("trending_up"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(2),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "chatbot-stat-number remaining",
                      class: _vm.getStatusClass(),
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.getRemainingSessionCount().toLocaleString()
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-progress-wrapper" }, [
                  _c("div", { staticClass: "chatbot-progress-container" }, [
                    _c("div", { staticClass: "chatbot-progress-bg" }, [
                      _c("div", {
                        staticClass: "chatbot-progress-fill",
                        class: _vm.getStatusClass(),
                        style: { width: _vm.getUsagePercentage() + "%" },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-divider" }),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-section-header" }, [
                  _c("span", { staticClass: "chatbot-header-title" }, [
                    _vm._v("Otomasyon Görevleri"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "chatbot-status-indicator",
                      class: _vm.getAutomationStatusClass(),
                    },
                    [
                      _c("span", { staticClass: "chatbot-status-dot" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "chatbot-status-text" }, [
                        _vm._v(_vm._s(_vm.getAutomationStatusText())),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      { staticClass: "chatbot-icon-box automation" },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("smart_toy"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-details" }, [
                      _c("div", { staticClass: "chatbot-stat-title" }, [
                        _vm._v("Toplam Otomasyon"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-desc" }, [
                        _vm._v(_vm._s(_vm.$t("message.maxAutomationTask"))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chatbot-stat-number automation" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.features.maxAutomationTask || 0).toLocaleString()
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      { staticClass: "chatbot-icon-box used-automation" },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("task_alt"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-details" }, [
                      _c("div", { staticClass: "chatbot-stat-title" }, [
                        _vm._v("Kullanılan Otomasyon"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-desc" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getAutomationUsagePercentage().toFixed(1)
                          ) + "% kullanıldı"
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "chatbot-stat-number used-automation" },
                    [
                      _vm._v(
                        _vm._s((_vm.totalAutomationUsage || 0).toLocaleString())
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      {
                        staticClass: "chatbot-icon-box remaining-auto",
                        class: _vm.getAutomationStatusClass(),
                      },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("hourglass_empty"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-details" }, [
                      _c("div", { staticClass: "chatbot-stat-title" }, [
                        _vm._v("Kalan Otomasyon"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-desc" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.remainingAutomationTask"))
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "chatbot-stat-number remaining-auto",
                      class: _vm.getAutomationStatusClass(),
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.getRemainingAutomationTask().toLocaleString()
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-progress-wrapper" }, [
                  _c("div", { staticClass: "chatbot-progress-container" }, [
                    _c("div", { staticClass: "chatbot-progress-bg" }, [
                      _c("div", {
                        staticClass: "chatbot-progress-fill",
                        class: _vm.getAutomationStatusClass(),
                        style: {
                          width: _vm.getAutomationUsagePercentage() + "%",
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isDropdownVisible
        ? _c("div", {
            staticClass: "dropdown-backdrop",
            on: { click: _vm.closeDropdown },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chatbot-stat-details" }, [
      _c("div", { staticClass: "chatbot-stat-title" }, [
        _vm._v("Free Chatbot"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "chatbot-stat-desc" }, [
        _vm._v("Paket içi ücretsiz"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chatbot-stat-details" }, [
      _c("div", { staticClass: "chatbot-stat-title" }, [
        _vm._v("Extra Chatbot"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "chatbot-stat-desc" }, [
        _vm._v("Ekstra satın alınan"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chatbot-stat-details" }, [
      _c("div", { staticClass: "chatbot-stat-title" }, [
        _vm._v("Kalan Chatbot"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "chatbot-stat-desc" }, [
        _vm._v("Kullanılabilir miktar"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }